module.exports = __webpack_public_path__ + "static/media/plus.1671e3c4.svg";